module.exports = __webpack_public_path__ + "img/bg_main0203.a6b0a543.png";